import api from './index'

const resource = 'counted_search_phrases'

export default {
  getCountedSearchPhrases () {
    return api.get(`${resource}`)
  }
}
